// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { Procedure_abstract } from './../abstract/SagaBase/Procedure_abstract';
export class Procedure extends Procedure_abstract {}
